export default __webpack_public_path__ + "static/media/LogoVH-B&W1.bd0d934f.svg";